import { createFileRoute } from '@tanstack/react-router';
import { USER_ROLES } from 'cpool-constants';

import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { partnerListSearchSchema } from '~/features/partnerManagement/schemas/SchemaPartnerListSearch';

export const Route = createFileRoute('/_app/management/partners/')({
    beforeLoad: ({ location }) => {
        // the overview shows the full partner record, including banking and commission data
        authoriseUser([USER_ROLES.admin, USER_ROLES.accountant_manager, USER_ROLES.corporation_director], location);
        const content = 'ROUTE_TITLE.PARTNER_MANAGEMENT';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    // no loader: the query depends on the search params, so the hooks fetch it
    validateSearch: partnerListSearchSchema,
});
